export enum RepresentativeType {
  SOCIO_REPRESENTANTE_LEGAL = 'Sócio e representante legal',
  ADMINISTRADOR = 'Administrador',
  PROCURADOR = 'Procurador',
  REPRESENTANTE_LEGAL = 'Representante Legal'
}
